import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from '@ui/dialog.tsx';
import { CreateUserForm } from './create-user-form.tsx';
import { useTranslation } from 'react-i18next';
import type { FC } from 'react';
import type { Option } from '@r/types/index.ts';
interface CreateNewUserDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  initialCompanyOption?: Option | null;
}

export const CreateNewUserDialog: FC<CreateNewUserDialogProps> = ({
  isOpen,
  onOpenChange,
  initialCompanyOption
}) => {
  const { t } = useTranslation();
  const handleSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="p-14 max-w-2xl max-h-[90vh] overflow-y-auto scrollable">
        <DialogHeader>
          <DialogTitle className="text-2xl">{t('user.create.dialog.title')}</DialogTitle>
          <DialogDescription>{t('user.create.dialog.description')}</DialogDescription>
        </DialogHeader>
        <div className="mt-6">
          <CreateUserForm onSuccess={handleSuccess} initialCompanyOption={initialCompanyOption} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
